import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { AudienceFilterFrequencyOperator } from 'app/audience/components/audience.model';

@Component({
  selector: 'app-frequency-selector',
  templateUrl: './frequency-selector.component.html',
  styleUrls: ['./frequency-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FrequencySelectorComponent {
  @Input() frequencyOperator: string;
  @Input() frequencyValue: UntypedFormControl;
  @Input() frequencyValueError: string;

  // Available frequency operators for the dropdown
  public FrequencyOperators = [AudienceFilterFrequencyOperator.Exactly, AudienceFilterFrequencyOperator.AtLeast];

  @Output() frequencyOperatorUpdated = new EventEmitter<string>();

  public filterFrequencyOperatorUpdated(frequencyOperator: string): void {
    this.frequencyOperatorUpdated.emit(frequencyOperator);
  }
}
